import { Transaction } from "@codemirror/state";

export const isTypingUpdate = (
  transactions: readonly Transaction[]
): boolean => {
  return transactions.some(tr => {
    if (!tr.docChanged) {
      return false;
    }
    const ev = tr.annotation(Transaction.userEvent);
    return (
      ev === "input.type" ||
      (ev?.startsWith("input.compose") ?? false) ||
      ev === "delete.backward" ||
      ev === "delete.forward"
    );
  });
};
